import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

// your reading of the book — separate from the translation work
const READING_STATUSES = [
  { value: 'want', label: 'want to read' },
  { value: 'reading', label: 'reading' },
  { value: 'on_hold', label: 'on hold' },
  { value: 'finished', label: 'finished' },
  { value: 'dropped', label: 'dropped' },
];

const TrashIcon = ({ size = 15, color = '#4a3d30' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6" />
    <path d="M14 11v6" />
    <path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
  </svg>
);

const ImageIcon = ({ size = 15, color = '#c9935a' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <circle cx="8.5" cy="8.5" r="1.5" />
    <path d="M21 15l-5-5L5 21" />
  </svg>
);

const DownloadIcon = ({ size = 15, color = '#c9935a' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3v12" />
    <polyline points="7 10 12 15 17 10" />
    <path d="M5 21h14" />
  </svg>
);

const UploadIcon = ({ size = 15, color = '#c9935a' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 21V9" />
    <polyline points="7 14 12 9 17 14" />
    <path d="M5 21h14" />
  </svg>
);

const PlusIcon = ({ size = 16, color = '#0e0b0f' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 5v14" />
    <path d="M5 12h14" />
  </svg>
);

const BookIcon = ({ size = 15, color = '#c9935a' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
  </svg>
);

const GearIcon = ({ size = 15, color = '#c9935a' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.32 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);

const GripIcon = ({ size = 16, color = '#8a7466' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color} aria-hidden="true">
    <circle cx="9" cy="6" r="1.6" /><circle cx="15" cy="6" r="1.6" />
    <circle cx="9" cy="12" r="1.6" /><circle cx="15" cy="12" r="1.6" />
    <circle cx="9" cy="18" r="1.6" /><circle cx="15" cy="18" r="1.6" />
  </svg>
);

const MoveIcon = ({ size = 14, color = '#c9935a' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M4 7h11" /><path d="m12 3 4 4-4 4" /><path d="M20 17H9" /><path d="m12 13-4 4 4 4" />
  </svg>
);

export default function NovelDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  const [novel, setNovel] = useState(null);
  const [chapters, setChapters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState('');

  const [creating, setCreating] = useState(false);

  const [showEpubModal, setShowEpubModal] = useState(false);
  const [epubFrom, setEpubFrom] = useState(1);
  const [epubTo, setEpubTo] = useState(1);
  const [generating, setGenerating] = useState(false);

  // cover
  const [uploadingCover, setUploadingCover] = useState(false);

  // epub import
  const [importingEpub, setImportingEpub] = useState(false);
  // a result worth reading that isn't a failure ("added 12, skipped 4")
  const [notice, setNotice] = useState('');
  // the file the language guard stopped, kept so "import anyway" has something
  // to send without asking you to pick it again
  const [pendingEpub, setPendingEpub] = useState(null);

  // rename
  const [renaming, setRenaming] = useState(false);
  const [titleDraft, setTitleDraft] = useState('');

  // batch translate
  const [selectedIds, setSelectedIds] = useState([]);
  const [models, setModels] = useState([]);
  const [selectedModel, setSelectedModel] = useState('');
  const [translating, setTranslating] = useState(false);
  // bulk translate chunks every chapter by default, 5k per piece, so no single
  // chapter is sent whole to the model (keeps it from skipping content). The
  // user can turn it off or resize per batch.
  const [batchChunked, setBatchChunked] = useState(true);
  const [batchChunkSize, setBatchChunkSize] = useState(5000);
  const [batchId, setBatchId] = useState(null);
  const [polishing, setPolishing] = useState(false);
  const [polishBatchId, setPolishBatchId] = useState(null);
  const [polishProgress, setPolishProgress] = useState(null);
  const [translateProgress, setTranslateProgress] = useState(null); // { done, total, currentTitle }

  // delete chapter
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);
  const [deleting, setDeleting] = useState(false);

  // reorder mode: drag the grip, or type a new position number
  const [reordering, setReordering] = useState(false);
  const [orderDraft, setOrderDraft] = useState([]);
  const [dragId, setDragId] = useState(null);
  const [savingOrder, setSavingOrder] = useState(false);
  const dragRef = useRef(null);
  const listRef = useRef(null);
  const bodyRef = useRef(null);

  // picking a run of chapters ("40 to 85") and moving them to another book
  const [showRange, setShowRange] = useState(false);
  const [rangeFrom, setRangeFrom] = useState('');
  const [rangeTo, setRangeTo] = useState('');
  const [showMove, setShowMove] = useState(false);
  const [books, setBooks] = useState([]);
  const [moveTarget, setMoveTarget] = useState('');
  const [newBookTitle, setNewBookTitle] = useState('');
  const [moving, setMoving] = useState(false);
  const [movedTo, setMovedTo] = useState(null);      // { id, title } for the "open it" link

  // deleting the whole book (it goes to recently deleted for 30 days)
  const [showDeleteBook, setShowDeleteBook] = useState(false);
  const [deleteTitleDraft, setDeleteTitleDraft] = useState('');
  const [deletingBook, setDeletingBook] = useState(false);
  const [showDeletedCosts, setShowDeletedCosts] = useState(false);

  // what this novel has cost, per chapter and per version. Counts the runs
  // that FAILED too — a refused or truncated piece was still generated and
  // still billed, and a total that skipped those would be the most misleading
  // number on the page.
  const [costs, setCosts] = useState(null);
  const [openCost, setOpenCost] = useState(null);   // which chapter's breakdown is showing
  // what the raws cost. Nothing can know this, so it's typed in by hand.
  const [editingBookCost, setEditingBookCost] = useState(false);
  const [bookCostDraft, setBookCostDraft] = useState('');

  // glossary — the novel's own name list, built automatically as chapters
  // translate. Editable here because the FIRST rendering is the one every later
  // chapter keeps, so being able to correct one is the whole point.
  const [showGlossary, setShowGlossary] = useState(false);
  const [glossary, setGlossary] = useState([]);
  const [glossaryLoading, setGlossaryLoading] = useState(false);
  const [captureModel, setCaptureModel] = useState('');
  const [newSrc, setNewSrc] = useState('');
  const [newEn, setNewEn] = useState('');
  const [newPronouns, setNewPronouns] = useState('');
  const [addingTerm, setAddingTerm] = useState(false);
  // a rename waiting for a yes: { id, oldEn, newEn, replaced, chapters }
  const [pendingRename, setPendingRename] = useState(null);
  const [renamingTerm, setRenamingTerm] = useState(false);

  const [showSettings, setShowSettings] = useState(false);
  const [translationPrompt, setTranslationPrompt] = useState('');
  const [polishPrompt, setPolishPrompt] = useState('');
  const [translationPromptDefault, setTranslationPromptDefault] = useState('');
  const [polishPromptDefault, setPolishPromptDefault] = useState('');
  const [savingPrompt, setSavingPrompt] = useState(false);

  useEffect(() => { fetchData(); fetchModels(); fetchCosts(); }, [id]);

  // If a batch is already running on the server (e.g. the user started one and
  // came back), pick it back up and resume showing progress.
  useEffect(() => {
    axios.get(`${API}/novels/${id}/batch-status?token=${token}`)
      .then(res => {
        const b = res.data.batch;
        if (b && b.status === 'running') {
          setBatchId(b.batch_id);
          setTranslating(true);
          setTranslateProgress({
            done: b.completed, total: b.total,
            currentTitle: b.current_title, status: b.status,
          });
          pollBatch(b.batch_id);
        }
      })
      .catch(() => {});
    // also resume any active polish batch
    axios.get(`${API}/novels/${id}/batch-polish-status?token=${token}`)
      .then(res => {
        const b = res.data.batch;
        if (b && b.status === 'running') {
          setPolishBatchId(b.batch_id);
          setPolishing(true);
          setPolishProgress({ done: b.completed, total: b.total, status: b.status });
          pollPolishBatch(b.batch_id);
        }
      })
      .catch(() => {});
  }, [id]);

  const describeError = (err) => {
    if (err.response) {
      const d = err.response.data?.detail;
      const detailText = Array.isArray(d)
        ? d.map(x => `${(x.loc || []).join('.')}: ${x.msg}`).join(' | ')
        : (typeof d === 'string' ? d : JSON.stringify(d));
      return `${err.response.status} — ${detailText || 'no detail'}`;
    }
    return err.message || 'network error';
  };

  const fetchData = () => {
    setLoading(true);
    Promise.all([
      axios.get(`${API}/novels/${id}?token=${token}`),
      axios.get(`${API}/novels/${id}/chapters?token=${token}`),
    ])
      .then(([novelRes, chaptersRes]) => {
        setNovel(novelRes.data.novel);
        setTitleDraft(novelRes.data.novel.title);
        setChapters(chaptersRes.data.chapters);
        if (chaptersRes.data.chapters.length > 0) {
          setEpubFrom(1);
          setEpubTo(chaptersRes.data.chapters.length);
        }
      })
      .catch(err => setErrorMsg(`couldn't load novel: ${describeError(err)}`))
      .finally(() => setLoading(false));
  };

  const uploadCover = (file) => {
    if (!file) return;
    setUploadingCover(true);
    setErrorMsg('');
    const formData = new FormData();
    formData.append('file', file);
    axios.post(`${API}/novels/${id}/cover?token=${token}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(res => {
        setNovel(prev => ({ ...prev, cover_url: res.data.cover_url }));
      })
      .catch(err => setErrorMsg(`cover upload failed: ${describeError(err)}`))
      .finally(() => setUploadingCover(false));
  };

  // ---- epub import: splits an uploaded .epub into chapters using its
  // internal spine order, one Chapter row per section, source_text filled
  // in automatically so translate/epub-export work immediately ----
  const importEpub = (file, allowAnyLanguage = false) => {
    if (!file) return;
    setImportingEpub(true);
    setErrorMsg('');
    setNotice('');
    setPendingEpub(null);
    const formData = new FormData();
    formData.append('file', file);
    const q = `token=${token}${allowAnyLanguage ? '&allow_any_language=true' : ''}`;
    axios.post(`${API}/novels/${id}/import-epub?${q}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(res => {
        refreshChapters();
        const { imported = 0, note } = res.data;
        if (note) { setErrorMsg(note); return; }
        if (imported > 0) {
          setNotice(`added ${imported} chapter${imported === 1 ? '' : 's'}`);
        }
      })
      .catch(err => {
        const detail = err.response?.data?.detail;
        // the language guard is a question, not a wall — keep the file so one
        // click can go ahead anyway
        if (err.response?.status === 400 && typeof detail === 'string'
            && detail.indexOf("doesn't look like Korean") !== -1) {
          setPendingEpub(file);
          setErrorMsg(detail);
          return;
        }
        setErrorMsg(`epub import failed: ${describeError(err)}`);
      })
      .finally(() => setImportingEpub(false));
  };

  const fetchModels = () => {
    axios.get(`${API}/translation-models?token=${token}`)
      .then(res => {
        setModels(res.data.models);
        if (res.data.models.length > 0) {
          const lastUsed = localStorage.getItem('lastTranslationModel');
          const stillValid = lastUsed && res.data.models.some(m => m.id === lastUsed);
          setSelectedModel(stillValid ? lastUsed : res.data.models[0].id);
        }
      })
      .catch(err => console.log(err));
  };

  const fetchPrompts = () => {
    axios.get(`${API}/settings/translation-prompt?token=${token}`)
      .then(res => {
        setTranslationPrompt(res.data.prompt || '');
        setTranslationPromptDefault(res.data.default_prompt || '');
      }).catch(() => {});
    axios.get(`${API}/settings/polish-prompt?token=${token}`)
      .then(res => {
        setPolishPrompt(res.data.prompt || '');
        setPolishPromptDefault(res.data.default_prompt || '');
      }).catch(() => {});
  };

  const saveTranslationPrompt = () => {
    setSavingPrompt(true);
    axios.put(`${API}/settings/translation-prompt`, { token, prompt: translationPrompt })
      .then(() => setErrorMsg(''))
      .catch(err => setErrorMsg(`save failed: ${describeError(err)}`))
      .finally(() => setSavingPrompt(false));
  };

  const savePolishPrompt = () => {
    setSavingPrompt(true);
    axios.put(`${API}/settings/polish-prompt`, { token, prompt: polishPrompt })
      .then(() => setErrorMsg(''))
      .catch(err => setErrorMsg(`save failed: ${describeError(err)}`))
      .finally(() => setSavingPrompt(false));
  };

  // ---- costs ----
  const fetchCosts = () => {
    axios.get(`${API}/novels/${id}/costs?token=${token}`)
      .then(res => setCosts(res.data))
      .catch(() => {});   // a missing cost figure must never break the page
  };

  // Model calls are cheap enough that two decimals would show every chapter as
  // $0.00, so small numbers keep four.
  // Korean in, English out. The ratio is worth seeing: Korean is dense, so a
  // healthy chapter comes out roughly twice as long in English, and a piece
  // that came back far shorter than that is usually a chapter the model
  // skipped part of.
  const chars = (n) => Number(n || 0).toLocaleString();
  const totalKo = chapters.reduce((a, c) => a + (c.source_chars || 0), 0);
  const totalEn = chapters.reduce((a, c) => a + (c.translated_chars || 0), 0);

  const money = (n) => {
    const v = Number(n || 0);
    return `$${v >= 1 ? v.toFixed(2) : v.toFixed(4)}`;
  };

  // ---- glossary ----
  const fetchGlossary = () => {
    setGlossaryLoading(true);
    axios.get(`${API}/novels/${id}/glossary?token=${token}`)
      .then(res => {
        setGlossary(res.data.terms || []);
        setCaptureModel(res.data.capture_model || '');
      })
      .catch(err => setErrorMsg(`couldn't load glossary: ${describeError(err)}`))
      .finally(() => setGlossaryLoading(false));
  };

  const addGlossaryTerm = () => {
    const src = newSrc.trim();
    const en = newEn.trim();
    if (!src || !en) return;
    setAddingTerm(true);
    axios.post(`${API}/novels/${id}/glossary`, {
      token, src, en, pronouns: newPronouns || null,
    })
      .then(res => {
        setGlossary(prev => [...prev, res.data.term]);
        setNewSrc(''); setNewEn(''); setNewPronouns('');
        setErrorMsg('');
      })
      .catch(err => setErrorMsg(`couldn't add term: ${describeError(err)}`))
      .finally(() => setAddingTerm(false));
  };

  // Saves on blur (and on every pronoun change) rather than behind a button:
  // the list is long and a save button per row would drown it.
  const updateGlossaryTerm = (termId, patch) => {
    const before = glossary;
    setGlossary(prev => prev.map(t => (t.id === termId ? { ...t, ...patch } : t)));
    axios.put(`${API}/novels/${id}/glossary/${termId}`, { token, ...patch })
      .then(res => setGlossary(prev => prev.map(t => (t.id === termId ? res.data.term : t))))
      .catch(err => {
        setGlossary(before);   // put the row back rather than lie about it
        setErrorMsg(`couldn't save term: ${describeError(err)}`);
      });
  };

  // Changing the English is not the same as changing anything else on a term.
  // Everywhere the old name is already written — the chapter you're reading,
  // every saved version, every piece — is still saying the old thing, so a
  // rename asks first and then rewrites the lot.
  const askRename = (term, nextEn) => {
    axios.post(`${API}/novels/${id}/glossary/${term.id}/rename`, {
      token, en: nextEn, dry_run: true,
    })
      .then(res => {
        const { replaced, chapters } = res.data;
        if (!replaced) {
          // the name isn't in any translated text yet, so there is nothing to
          // ask about — just save it
          updateGlossaryTerm(term.id, { en: nextEn });
          return;
        }
        setPendingRename({ id: term.id, oldEn: term.en, newEn: nextEn, replaced, chapters });
      })
      .catch(err => setErrorMsg(`couldn't check that rename: ${describeError(err)}`));
  };

  const confirmRename = () => {
    if (!pendingRename) return;
    setRenamingTerm(true);
    axios.post(`${API}/novels/${id}/glossary/${pendingRename.id}/rename`, {
      token, en: pendingRename.newEn,
    })
      .then(res => {
        setGlossary(prev => prev.map(t => (t.id === res.data.term.id ? res.data.term : t)));
        setNotice(`renamed in ${res.data.replaced} place${res.data.replaced === 1 ? '' : 's'} across ${res.data.chapters} chapter${res.data.chapters === 1 ? '' : 's'}`);
        setPendingRename(null);
        refreshChapters();   // the character counts move when the text does
      })
      .catch(err => setErrorMsg(`rename failed: ${describeError(err)}`))
      .finally(() => setRenamingTerm(false));
  };

  const deleteGlossaryTerm = (termId) => {
    const before = glossary;
    setGlossary(prev => prev.filter(t => t.id !== termId));
    axios.delete(`${API}/novels/${id}/glossary/${termId}?token=${token}`)
      .catch(err => {
        setGlossary(before);
        setErrorMsg(`couldn't delete term: ${describeError(err)}`);
      });
  };

  const refreshChapters = () => {
    axios.get(`${API}/novels/${id}/chapters?token=${token}`)
      .then(res => setChapters(res.data.chapters))
      .catch(err => console.log(err));
  };

  const createChapter = () => {
    setCreating(true);
    setErrorMsg('');
    const nextNum = chapters.length + 1;
    axios.post(`${API}/novels/${id}/chapters`, {
      token,
      title: `Chapter ${nextNum}`,
    })
      .then(res => {
        navigate(`/novels/${id}/chapters/${res.data.chapter.id}`);
      })
      .catch(err => setErrorMsg(`couldn't create chapter: ${describeError(err)}`))
      .finally(() => setCreating(false));
  };

  // ---- reading log ----
  // Every change saves straight away. Picking "reading", "finished" or
  // "dropped" fills in this month on the server if the month is still empty.
  const [dropReasonDraft, setDropReasonDraft] = useState(null);

  const saveReading = (patch) => {
    setErrorMsg('');
    // show it immediately; the server's answer (with any auto-filled month) follows
    setNovel(prev => ({ ...prev, ...patch }));
    axios.put(`${API}/novels/${id}`, { token, ...patch })
      .then(res => setNovel(prev => ({
        ...prev,
        reading_status: res.data.reading_status,
        started_month: res.data.started_month,
        finished_month: res.data.finished_month,
        stopped_chapter_id: res.data.stopped_chapter_id,
        drop_reason: res.data.drop_reason,
      })))
      .catch(err => {
        setErrorMsg(`couldn't save reading status: ${describeError(err)}`);
        fetchData();
      });
  };

  const saveDropReason = () => {
    if (dropReasonDraft === null) return;
    const next = dropReasonDraft.trim();
    setDropReasonDraft(null);
    if (next === (novel?.drop_reason || '')) return;
    saveReading({ drop_reason: next });
  };

  // ---- rename ----
  const saveBookCost = () => {
    setEditingBookCost(false);
    const raw = bookCostDraft.trim().replace(/[^0-9.]/g, '');
    const value = raw === '' ? 0 : Number(raw);
    if (!Number.isFinite(value) || value < 0) return;
    if (costs && value === Number(costs.book_cost_usd || 0)) return;
    axios.put(`${API}/novels/${id}`, { token, book_cost_usd: value })
      .then(() => fetchCosts())
      .catch(err => setErrorMsg(`couldn't save the book cost: ${describeError(err)}`));
  };

  const saveRename = () => {
    if (!titleDraft.trim() || titleDraft.trim() === novel?.title) {
      setRenaming(false);
      setTitleDraft(novel?.title || '');
      return;
    }
    axios.put(`${API}/novels/${id}`, { token, title: titleDraft.trim() })
      .then(res => {
        setNovel(prev => ({ ...prev, title: res.data.title }));
        setRenaming(false);
      })
      .catch(err => setErrorMsg(`rename failed: ${describeError(err)}`));
  };

  // ---- chapter selection (for batch translate) ----
  const toggleSelected = (chapterId) => {
    setSelectedIds(prev =>
      prev.includes(chapterId) ? prev.filter(x => x !== chapterId) : [...prev, chapterId]
    );
  };

  // ---- batch translate (server-side) ----
  // The server runs the whole batch sequentially in the background, so we just
  // start it and poll for progress; the run survives the app being closed.
  // Kick off a SERVER-SIDE batch: one POST starts it, then we just poll for
  // progress. The chapters are translated on the server one after another, so
  // the user can close the app and come back — the run keeps going and the
  // progress display resumes from the batch status on reload.
  const pollBatch = (batchId) => {
    const tick = () => {
      axios.get(`${API}/novels/${id}/batch-status?token=${token}&batch_id=${batchId}`)
        .then(res => {
          const b = res.data.batch;
          if (!b) { setTranslating(false); setTranslateProgress(null); return; }
          setTranslateProgress({
            done: b.completed, total: b.total,
            currentTitle: b.current_title, status: b.status,
          });
          if (b.status === 'running') {
            setTimeout(tick, 4000);
          } else {
            // done or cancelled
            setTranslating(false);
            setBatchId(null);
            localStorage.removeItem(`activeBatch:${id}`);
            refreshChapters();
            fetchCosts();
            if (b.failures && b.failures.length > 0) {
              setErrorMsg(`${b.failures.length} chapter(s) failed: ${b.failures.join(' | ')}`);
            }
            setTimeout(() => setTranslateProgress(null), 4000);
          }
        })
        .catch(() => setTimeout(tick, 6000));
    };
    tick();
  };

  const batchTranslate = async () => {
    if (selectedIds.length === 0 || !selectedModel) return;
    setTranslating(true);
    setErrorMsg('');
    try {
      const res = await axios.post(`${API}/novels/${id}/batch-translate`, {
        token,
        model: selectedModel,
        chapter_ids: selectedIds,
        chunked: batchChunked,
        chunk_size: batchChunked ? Number(batchChunkSize) : null,
      });
      const batchId = res.data.batch_id;
      setBatchId(batchId);
      localStorage.setItem(`activeBatch:${id}`, batchId);
      setSelectedIds([]);
      setTranslateProgress({ done: 0, total: res.data.total, currentTitle: null, status: 'running' });
      pollBatch(batchId);
    } catch (err) {
      setTranslating(false);
      setErrorMsg(`couldn't start batch: ${describeError(err)}`);
    }
  };

  const cancelBatch = () => {
    if (!batchId) return;
    axios.post(`${API}/novels/${id}/batch-translate/${batchId}/cancel`, { token })
      .then(() => setErrorMsg('batch will stop after the current chapter finishes'))
      .catch(err => setErrorMsg(`couldn't cancel: ${describeError(err)}`));
  };

  // ---- batch polish (server-side, parallel) ----
  const pollPolishBatch = (bid) => {
    const tick = () => {
      axios.get(`${API}/novels/${id}/batch-polish-status?token=${token}&batch_id=${bid}`)
        .then(res => {
          const b = res.data.batch;
          if (!b) { setPolishing(false); setPolishProgress(null); return; }
          setPolishProgress({ done: b.completed, total: b.total, status: b.status });
          if (b.status === 'running') {
            setTimeout(tick, 4000);
          } else {
            setPolishing(false);
            setPolishBatchId(null);
            refreshChapters();
            fetchCosts();
            if (b.failures && b.failures.length > 0) {
              setErrorMsg(`${b.failures.length} chapter(s) failed to polish: ${b.failures.join(' | ')}`);
            }
            setTimeout(() => setPolishProgress(null), 4000);
          }
        })
        .catch(() => setTimeout(tick, 6000));
    };
    tick();
  };

  const batchPolish = async () => {
    if (selectedIds.length === 0 || !selectedModel) return;
    setPolishing(true);
    setErrorMsg('');
    try {
      const res = await axios.post(`${API}/novels/${id}/batch-polish`, {
        token, model: selectedModel,
        chapter_ids: selectedIds,
        chunk_size: 5000,
      });
      const bid = res.data.batch_id;
      setPolishBatchId(bid);
      setSelectedIds([]);
      setPolishProgress({ done: 0, total: res.data.total, status: 'running' });
      pollPolishBatch(bid);
    } catch (err) {
      setPolishing(false);
      setErrorMsg(`couldn't start polish batch: ${describeError(err)}`);
    }
  };

  const cancelPolishBatch = () => {
    if (!polishBatchId) return;
    axios.post(`${API}/novels/${id}/batch-polish/${polishBatchId}/cancel`, { token })
      .then(() => setErrorMsg('polish batch cancelled'))
      .catch(err => setErrorMsg(`couldn't cancel: ${describeError(err)}`));
  };

  // ---- delete chapter ----
  const deleteChapter = (chapterId) => {
    setDeleting(true);
    axios.delete(`${API}/novels/${id}/chapters/${chapterId}?token=${token}`)
      .then(() => {
        setChapters(prev => prev.filter(c => c.id !== chapterId));
        setSelectedIds(prev => prev.filter(x => x !== chapterId));
        setConfirmDeleteId(null);
        setMovedTo(null);
        setNotice('chapter deleted — you can bring it back from "recently deleted" in your library');
        fetchCosts();
      })
      .catch(err => setErrorMsg(`couldn't delete chapter: ${describeError(err)}`))
      .finally(() => setDeleting(false));
  };

  // ---- reorder ----
  const startReorder = () => {
    setOrderDraft(chapters);
    setReordering(true);
    setConfirmDeleteId(null);
    setOpenCost(null);
    setErrorMsg('');
  };
  const cancelReorder = () => { setReordering(false); setOrderDraft([]); setDragId(null); };

  const moveTo = (chapterId, position) => {
    setOrderDraft(prev => {
      const from = prev.findIndex(c => c.id === chapterId);
      if (from < 0) return prev;
      const to = Math.max(0, Math.min(prev.length - 1, position));
      if (from === to) return prev;
      const next = [...prev];
      const [m] = next.splice(from, 1);
      next.splice(to, 0, m);
      return next;
    });
  };

  // dragging works with a finger on the iPad as well as a mouse: the grip
  // captures the pointer, and the chapter slots in wherever you hold it
  const onGripDown = (e, chapterId) => {
    e.preventDefault();
    try { e.currentTarget.setPointerCapture(e.pointerId); } catch (err) { /* fine */ }
    dragRef.current = { id: chapterId };
    setDragId(chapterId);
  };
  const onGripMove = (e) => {
    if (!dragRef.current || !listRef.current) return;
    const y = e.clientY;
    const body = bodyRef.current;
    if (body) {
      const r = body.getBoundingClientRect();
      if (y < r.top + 70) body.scrollTop -= 14;
      else if (y > r.bottom - 70) body.scrollTop += 14;
    }
    const others = Array.from(listRef.current.querySelectorAll('[data-cid]'))
      .filter(el => el.dataset.cid !== dragRef.current.id);
    let slot = 0;
    others.forEach(el => {
      const rc = el.getBoundingClientRect();
      if (y > rc.top + rc.height / 2) slot += 1;
    });
    moveTo(dragRef.current.id, slot);
  };
  const onGripUp = () => { dragRef.current = null; setDragId(null); };

  const saveOrder = () => {
    setSavingOrder(true);
    setErrorMsg('');
    axios.put(`${API}/novels/${id}/chapter-order`, { token, chapter_ids: orderDraft.map(c => c.id) })
      .then(() => {
        setChapters(orderDraft);
        setReordering(false);
        setOrderDraft([]);
        setMovedTo(null);
        setNotice('new order saved');
      })
      .catch(err => setErrorMsg(`couldn't save the order: ${describeError(err)}`))
      .finally(() => setSavingOrder(false));
  };

  // ---- pick a run of chapters ----
  const selectRange = () => {
    const a = parseInt(rangeFrom, 10);
    const b = parseInt(rangeTo, 10);
    if (!a || !b) return;
    const lo = Math.max(1, Math.min(a, b));
    const hi = Math.min(chapters.length, Math.max(a, b));
    const ids = chapters.slice(lo - 1, hi).map(c => c.id);
    setSelectedIds(prev => Array.from(new Set([...prev, ...ids])));
    setShowRange(false);
  };

  // ---- move chapters to another book ----
  const openMove = () => {
    setShowMove(true);
    setMoveTarget('');
    setNewBookTitle('');
    setErrorMsg('');
    axios.get(`${API}/novels?token=${token}`)
      .then(res => setBooks((res.data.novels || []).filter(n => n.id !== id)))
      .catch(err => setErrorMsg(`couldn't load your books: ${describeError(err)}`));
  };

  const doMove = () => {
    if (!selectedIds.length || (!moveTarget || (moveTarget === 'new' && !newBookTitle.trim()))) return;
    setMoving(true);
    setErrorMsg('');
    // keep the order they're in on this page
    const ids = chapters.filter(c => selectedIds.includes(c.id)).map(c => c.id);
    axios.post(`${API}/novels/${id}/move-chapters`, {
      token,
      chapter_ids: ids,
      ...(moveTarget === 'new' ? { new_novel_title: newBookTitle.trim() } : { target_novel_id: moveTarget }),
    })
      .then(res => {
        const d = res.data;
        setShowMove(false);
        setSelectedIds([]);
        refreshChapters();
        fetchCosts();
        setMovedTo({ id: d.target_novel_id, title: d.target_title });
        setNotice(`moved ${d.moved} chapter${d.moved === 1 ? '' : 's'} to ${d.target_title}`
          + (d.glossary_copied ? ` · ${d.glossary_copied} name${d.glossary_copied === 1 ? '' : 's'} copied to its glossary` : ''));
      })
      .catch(err => setErrorMsg(`couldn't move them: ${describeError(err)}`))
      .finally(() => setMoving(false));
  };

  // ---- delete the whole book ----
  const deleteBook = () => {
    if (deleteTitleDraft.trim() !== (novel?.title || '').trim()) return;
    setDeletingBook(true);
    axios.delete(`${API}/novels/${id}?token=${token}`)
      .then(() => navigate('/novels'))
      .catch(err => { setErrorMsg(`couldn't delete the book: ${describeError(err)}`); setDeletingBook(false); });
  };

  // ---- epub export ----
  // Two things worth knowing here:
  //  1. Only TRANSLATED chapters get sent. The backend rejects the whole
  //     request if any selected chapter has no translation, so silently
  //     skipping untranslated ones in the range is much friendlier than
  //     failing the entire export.
  //  2. responseType 'blob' means an error body also arrives as a Blob, so
  //     err.response.data.detail is undefined — we read the Blob as text and
  //     parse it, otherwise every failure shows up as "no detail".
  const describeBlobError = async (err) => {
    if (err.response?.data instanceof Blob) {
      try {
        const text = await err.response.data.text();
        const parsed = JSON.parse(text);
        const d = parsed?.detail;
        const detailText = Array.isArray(d)
          ? d.map(x => `${(x.loc || []).join('.')}: ${x.msg}`).join(' | ')
          : (typeof d === 'string' ? d : JSON.stringify(d));
        return `${err.response.status} — ${detailText || 'no detail'}`;
      } catch (e) {
        return `${err.response.status} — could not read error body`;
      }
    }
    return describeError(err);
  };

  const generateEpub = async () => {
    const from = Math.max(1, Math.min(epubFrom, epubTo));
    const to = Math.min(chapters.length, Math.max(epubFrom, epubTo));
    const inRange = chapters.slice(from - 1, to);
    const translatedInRange = inRange.filter(c => c.is_translated);
    const skipped = inRange.length - translatedInRange.length;

    if (translatedInRange.length === 0) {
      setErrorMsg('none of the chapters in that range are translated yet — translate some first');
      return;
    }

    setGenerating(true);
    setErrorMsg('');
    try {
      const res = await axios.post(
        `${API}/novels/${id}/generate-epub`,
        { token, chapter_ids: translatedInRange.map(c => c.id) },
        { responseType: 'blob' }
      );
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${novel?.title || 'novel'}.epub`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      setShowEpubModal(false);
      if (skipped > 0) {
        setErrorMsg(`epub created with ${translatedInRange.length} chapter(s) — skipped ${skipped} untranslated chapter(s)`);
      }
    } catch (err) {
      setErrorMsg(`epub generation failed: ${await describeBlobError(err)}`);
    } finally {
      setGenerating(false);
    }
  };

  const selectAllForEpub = () => {
    setEpubFrom(1);
    setEpubTo(chapters.length);
  };

  const s = {
    page: {
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: '#0e0b0f',
      fontFamily: "'DM Sans', sans-serif",
      fontWeight: 300,
      color: '#e8ddd0',
      display: 'flex', flexDirection: 'column',
      overflowY: 'hidden',
    },
    header: {
      padding: '20px 28px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderBottom: '1px solid rgba(201,147,90,0.06)',
      background: 'linear-gradient(180deg, #120f18 0%, #0e0b0f 100%)',
      flexShrink: 0,
      zIndex: 50,
      gap: '12px',
    },
    backBtn: {
      display: 'flex', alignItems: 'center', gap: '8px',
      background: 'transparent', border: 'none', cursor: 'pointer',
      color: '#4a3d30', fontSize: '13px', fontFamily: "'DM Sans', sans-serif",
      flexShrink: 0,
    },
    headerTitle: {
      fontFamily: "'Cormorant Garamond', serif",
      fontSize: '18px', fontStyle: 'italic', color: '#e8ddd0',
      whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', flex: 1, textAlign: 'center',
      cursor: 'pointer',
    },
    headerTitleInput: {
      fontFamily: "'Cormorant Garamond', serif",
      fontSize: '18px', fontStyle: 'italic', color: '#e8ddd0',
      background: 'transparent', border: 'none', borderBottom: '1px solid rgba(201,147,90,0.3)',
      outline: 'none', flex: 1, textAlign: 'center', minWidth: 0,
    },
    headerActions: { display: 'flex', gap: '8px', flexShrink: 0 },
    smallBtn: {
      padding: '8px 14px', borderRadius: '20px',
      border: '1px solid rgba(201,147,90,0.2)', background: 'transparent',
      color: '#c9935a', fontSize: '12px', cursor: 'pointer',
      fontFamily: "'DM Sans', sans-serif", fontWeight: 300, whiteSpace: 'nowrap',
      display: 'inline-flex', alignItems: 'center', gap: '6px',
    },
    smallBtnFilled: {
      padding: '8px 14px', borderRadius: '20px', border: 'none',
      background: 'linear-gradient(135deg, #8a5f35, #c9935a)', color: '#0e0b0f',
      fontSize: '12px', cursor: 'pointer', fontWeight: 400, whiteSpace: 'nowrap',
    },
    smallBtnDisabled: {
      padding: '8px 14px', borderRadius: '20px', border: 'none',
      background: 'rgba(201,147,90,0.15)', color: 'rgba(201,147,90,0.4)',
      fontSize: '12px', fontWeight: 400, whiteSpace: 'nowrap', cursor: 'not-allowed',
    },
    coverBtn: {
      width: '34px', height: '34px', borderRadius: '50%',
      border: '1px solid rgba(201,147,90,0.2)', background: 'transparent',
      cursor: 'pointer', display: 'inline-flex', alignItems: 'center',
      justifyContent: 'center', flexShrink: 0,
    },
    plusBtn: {
      width: '34px', height: '34px', borderRadius: '50%', border: 'none',
      background: 'linear-gradient(135deg, #8a5f35, #c9935a)',
      cursor: 'pointer', display: 'inline-flex', alignItems: 'center',
      justifyContent: 'center', flexShrink: 0,
    },
    coverStrip: {
      display: 'flex', alignItems: 'center', gap: '10px',
      padding: '10px 24px', borderBottom: '1px solid rgba(201,147,90,0.06)',
      flexShrink: 0,
    },
    coverThumb: {
      width: '32px', height: '44px', objectFit: 'cover', borderRadius: '4px',
      boxShadow: '0 0 0 1px rgba(201,147,90,0.15)',
    },
    coverStripText: { fontSize: '11px', color: '#4a3d30' },
    // Outside the scrolling body on purpose: what a novel has cost you is the
    // sort of number you want in view while you tick chapters and hit
    // translate, not one you have to scroll back up to find.
    readingStrip: {
      display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap',
      padding: '9px 24px', borderBottom: '1px solid rgba(201,147,90,0.06)',
      background: '#120f18', flexShrink: 0, fontSize: '12px',
    },
    readingGroup: { display: 'inline-flex', alignItems: 'center', gap: '6px' },
    readingSelect: {
      background: '#0e0b0f', border: '1px solid rgba(201,147,90,0.2)',
      borderRadius: '8px', padding: '4px 8px', color: '#e8ddd0',
      fontSize: '12px', fontFamily: "'DM Sans', sans-serif", outline: 'none',
      maxWidth: '180px',
    },
    readingMonth: {
      background: '#0e0b0f', border: '1px solid rgba(201,147,90,0.2)',
      borderRadius: '8px', padding: '3px 6px', color: '#e8ddd0',
      fontSize: '12px', fontFamily: "'DM Sans', sans-serif", outline: 'none',
      colorScheme: 'dark', width: '138px',
    },
    readingReason: {
      flex: 1, minWidth: '160px', background: '#0e0b0f',
      border: '1px solid rgba(201,147,90,0.2)', borderRadius: '8px',
      padding: '5px 8px', color: '#e8ddd0', fontSize: '12px',
      fontFamily: "'DM Sans', sans-serif", outline: 'none',
    },
    notesBtn: {
      marginLeft: 'auto', padding: '6px 14px', borderRadius: '20px',
      border: '1px solid rgba(201,147,90,0.25)', background: 'transparent',
      color: '#c9935a', fontSize: '12px', cursor: 'pointer',
      fontFamily: "'DM Sans', sans-serif", whiteSpace: 'nowrap',
    },
    notesPreview: {
      width: '100%', fontSize: '11px', color: '#8a7466', cursor: 'pointer',
      overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
    },
    spendStrip: {
      display: 'flex', alignItems: 'baseline', gap: '10px', flexWrap: 'wrap',
      padding: '9px 24px', borderBottom: '1px solid rgba(201,147,90,0.06)',
      background: '#120f18', flexShrink: 0,
    },
    spendLabel: {
      fontSize: '10px', letterSpacing: '0.14em', textTransform: 'uppercase',
      color: '#4a3d30',
    },
    spendFigure: {
      fontFamily: "'Cormorant Garamond', serif", fontSize: '19px',
      color: '#c9935a', lineHeight: 1,
    },
    spendDetail: { fontSize: '11px', color: '#4a3d30' },
    spendSep: { color: 'rgba(201,147,90,0.22)' },
    spendGroup: { display: 'flex', alignItems: 'baseline', gap: '7px' },
    spendFigureQuiet: {
      fontFamily: "'Cormorant Garamond', serif", fontSize: '19px',
      color: '#e8ddd0', lineHeight: 1, cursor: 'pointer',
      borderBottom: '1px dashed rgba(201,147,90,0.3)',
    },
    spendInput: {
      width: '82px', background: '#0e0b0f',
      border: '1px solid rgba(201,147,90,0.3)', borderRadius: '6px',
      padding: '3px 7px', color: '#e8ddd0', fontSize: '14px',
      fontFamily: "'DM Sans', sans-serif", outline: 'none',
    },
    settingsPanel: {
      padding: '16px 24px', borderBottom: '1px solid rgba(201,147,90,0.1)',
      background: '#1e1825', flexShrink: 0, maxHeight: '45vh', overflowY: 'auto',
    },
    settingsTitle: {
      fontFamily: "'Cormorant Garamond', serif", fontSize: '18px', fontStyle: 'italic',
      color: '#e8ddd0', marginBottom: '14px',
    },
    settingsLabel: {
      fontSize: '11px', letterSpacing: '0.12em', color: '#4a3d30',
      textTransform: 'uppercase', marginBottom: '6px',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    },
    settingsResetBtn: {
      background: 'transparent', border: 'none', color: '#c9935a',
      fontSize: '10px', cursor: 'pointer', fontFamily: "'DM Sans', sans-serif",
    },
    settingsTextarea: {
      width: '100%', height: '120px', boxSizing: 'border-box', resize: 'vertical',
      background: '#120f18', border: '1px solid rgba(201,147,90,0.12)',
      borderRadius: '8px', padding: '10px 12px', color: '#e8ddd0',
      fontSize: '12px', lineHeight: 1.6, fontFamily: "'DM Sans', sans-serif",
      outline: 'none', marginBottom: '8px',
    },
    settingsSaveBtn: {
      padding: '8px 16px', borderRadius: '20px', border: 'none',
      background: 'linear-gradient(135deg, #8a5f35, #c9935a)', color: '#0e0b0f',
      fontSize: '12px', cursor: 'pointer', fontWeight: 400,
      fontFamily: "'DM Sans', sans-serif",
    },
    // the polish button referenced s.polishBtn, which was never defined —
    // React silently dropped the style and the button rendered bare
    polishBtn: {
      padding: '8px 14px', borderRadius: '20px', border: '1px solid rgba(201,147,90,0.35)',
      background: 'transparent', color: '#c9935a',
      fontSize: '12px', cursor: 'pointer', fontWeight: 400, whiteSpace: 'nowrap',
      fontFamily: "'DM Sans', sans-serif",
    },
    glossaryPanel: {
      padding: '16px 24px', borderBottom: '1px solid rgba(201,147,90,0.1)',
      background: '#1e1825', flexShrink: 0, maxHeight: '55vh', overflowY: 'auto',
    },
    glossaryHint: {
      fontSize: '11px', color: '#4a3d30', lineHeight: 1.7, marginBottom: '14px',
    },
    glossaryRow: {
      display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px',
    },
    glossaryInput: {
      flex: 1, minWidth: 0, background: '#120f18',
      border: '1px solid rgba(201,147,90,0.12)', borderRadius: '8px',
      padding: '7px 10px', color: '#e8ddd0', fontSize: '12px',
      fontFamily: "'DM Sans', sans-serif", outline: 'none',
    },
    glossaryArrow: { color: '#4a3d30', fontSize: '12px', flexShrink: 0 },
    glossaryKind: {
      fontSize: '9px', letterSpacing: '0.1em', textTransform: 'uppercase',
      color: 'rgba(201,147,90,0.4)', width: '40px', flexShrink: 0,
      textAlign: 'right',
    },
    pronounSelect: {
      background: '#120f18', border: '1px solid rgba(201,147,90,0.12)',
      borderRadius: '8px', padding: '7px 8px', color: '#c9935a',
      fontSize: '11px', fontFamily: "'DM Sans', sans-serif", outline: 'none',
      flexShrink: 0, width: '92px',
    },
    glossaryDelete: {
      background: 'transparent', border: 'none', cursor: 'pointer',
      color: '#4a3d30', flexShrink: 0, padding: '4px', lineHeight: 1,
    },
    renameBar: {
      background: 'rgba(201,147,90,0.10)', border: '1px solid rgba(201,147,90,0.3)',
      borderRadius: '12px', padding: '12px 14px', marginBottom: '12px',
      fontSize: '12px', color: '#e8ddd0', lineHeight: 1.6,
    },
    renameActions: { display: 'flex', gap: '8px', marginTop: '10px', flexWrap: 'wrap' },
    glossaryAddRow: {
      display: 'flex', alignItems: 'center', gap: '8px', marginTop: '14px',
      paddingTop: '14px', borderTop: '1px solid rgba(201,147,90,0.1)',
    },
    glossaryCount: {
      fontSize: '10px', letterSpacing: '0.12em', color: '#4a3d30',
      textTransform: 'uppercase', marginTop: '14px',
    },
    // the whole width scrolls (so you can swipe on the sides on an iPad),
    // while the content itself stays the same 680px column in the middle
    body: {
      flex: 1, overflowY: 'auto', overflowX: 'hidden', WebkitOverflowScrolling: 'touch', overscrollBehavior: 'contain',
      paddingTop: '20px', paddingBottom: '80px',
      paddingLeft: 'max(24px, calc((100% - 632px) / 2))', paddingRight: 'max(24px, calc((100% - 632px) / 2))',
      width: '100%', boxSizing: 'border-box',
    },
    errorBanner: {
      background: 'rgba(180,60,60,0.12)', border: '1px solid rgba(220,100,100,0.3)',
      borderRadius: '12px', padding: '12px 16px', marginBottom: '16px',
      fontSize: '12px', color: '#e0a0a0', wordBreak: 'break-word',
    },
    noticeBanner: {
      background: 'rgba(201,147,90,0.10)', border: '1px solid rgba(201,147,90,0.28)',
      borderRadius: '12px', padding: '12px 16px', marginBottom: '16px',
      fontSize: '12px', color: '#c9935a', wordBreak: 'break-word',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px',
    },
    batchBar: {
      display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap',
      background: '#1e1825', border: '1px solid rgba(201,147,90,0.1)',
      borderRadius: '14px', padding: '12px 14px', marginBottom: '16px',
    },
    batchLabel: { fontSize: '12px', color: '#4a3d30', flexShrink: 0 },
    modelSelect: {
      background: '#120f18', border: '1px solid rgba(201,147,90,0.15)',
      borderRadius: '10px', padding: '7px 10px', color: '#e8ddd0',
      fontSize: '12px', fontFamily: "'DM Sans', sans-serif", outline: 'none',
      maxWidth: '160px',
    },
    progressText: { fontSize: '11px', color: '#c9935a', width: '100%' },
    sectionTitle: {
      fontSize: '11px', letterSpacing: '0.16em', color: '#4a3d30',
      textTransform: 'uppercase', marginBottom: '16px',
    },
    // The labelled way to add a volume. It used to exist only in the empty
    // state, which meant it vanished the moment a novel had chapters — i.e.
    // on exactly the novels you'd want to add a second volume to.
    sectionHeadRow: {
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      gap: '12px', marginBottom: '16px',
    },
    reorderActions: { display: 'flex', alignItems: 'center', gap: '6px', flexShrink: 0 },
    reorderHint: { fontSize: '11.5px', color: '#8a7466', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '4px', flexWrap: 'wrap' },
    reorderCard: { padding: '10px 12px', transition: 'box-shadow .15s, border-color .15s' },
    reorderCardDragging: { borderColor: 'rgba(201,147,90,0.55)', boxShadow: '0 10px 26px rgba(0,0,0,0.5)', background: '#241d2c' },
    grip: {
      width: '34px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center',
      cursor: 'grab', touchAction: 'none', flexShrink: 0, borderRadius: '8px', userSelect: 'none', WebkitUserSelect: 'none',
    },
    positionInput: {
      width: '46px', flexShrink: 0, textAlign: 'center', background: '#120f18', border: '1px solid rgba(201,147,90,0.18)',
      borderRadius: '10px', padding: '7px 4px', color: '#c9935a', fontSize: '13px', fontFamily: "'DM Sans', sans-serif",
      outline: 'none', fontVariantNumeric: 'tabular-nums',
    },
    edgeBtn: {
      background: 'transparent', border: '1px solid rgba(201,147,90,0.14)', borderRadius: '12px', padding: '5px 9px',
      color: '#8a7466', fontSize: '11px', cursor: 'pointer', fontFamily: "'DM Sans', sans-serif", flexShrink: 0,
    },
    rangeRow: { display: 'inline-flex', alignItems: 'center', gap: '6px' },
    rangeInput: {
      width: '52px', background: '#120f18', border: '1px solid rgba(201,147,90,0.15)', borderRadius: '10px',
      padding: '6px 8px', color: '#e8ddd0', fontSize: '12px', fontFamily: "'DM Sans', sans-serif", outline: 'none',
    },
    bookPick: { display: 'flex', flexDirection: 'column', gap: '6px', overflowY: 'auto', marginBottom: '16px', maxHeight: '45vh' },
    bookOption: (on) => ({
      display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 12px', borderRadius: '12px', cursor: 'pointer',
      border: on ? '1px solid rgba(201,147,90,0.5)' : '1px solid rgba(201,147,90,0.1)',
      background: on ? 'rgba(201,147,90,0.08)' : 'transparent', fontSize: '13px', color: '#e8ddd0',
    }),
    bookOptionTitle: { flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
    bookOptionSub: { fontSize: '11px', color: '#6d5d4e', flexShrink: 0 },
    deleteBookRow: { marginTop: '34px', textAlign: 'center' },
    deleteBookLink: {
      background: 'none', border: 'none', color: '#6d5d4e', fontSize: '12px', cursor: 'pointer',
      fontFamily: "'DM Sans', sans-serif", textDecoration: 'underline', textUnderlineOffset: '3px',
    },
    deleteSummary: { fontSize: '13px', color: '#c9b8a6', lineHeight: 1.7, marginBottom: '14px' },
    dangerBtn: {
      padding: '9px 18px', borderRadius: '20px', border: 'none', background: '#9c4545', color: '#f4e6e6',
      fontSize: '13px', cursor: 'pointer', fontFamily: "'DM Sans', sans-serif",
    },
    inlineLink: {
      background: 'none', border: 'none', padding: 0, color: '#e8ddd0', fontSize: '12px', cursor: 'pointer',
      fontFamily: "'DM Sans', sans-serif", textDecoration: 'underline', textUnderlineOffset: '2px',
    },
    deletedCostBtn: {
      background: 'none', border: 'none', padding: 0, color: '#4a3d30', fontSize: '11px', cursor: 'pointer',
      fontFamily: "'DM Sans', sans-serif",
    },
    deletedCostList: { width: '100%', paddingTop: '4px' },
    addVolumeBtn: {
      padding: '7px 13px', borderRadius: '20px',
      border: '1px solid rgba(201,147,90,0.2)', background: 'transparent',
      color: '#c9935a', fontSize: '11px', cursor: 'pointer',
      fontFamily: "'DM Sans', sans-serif", fontWeight: 300, whiteSpace: 'nowrap',
      display: 'inline-flex', alignItems: 'center', gap: '6px',
    },
    chapterCard: {
      background: '#1e1825',
      border: '1px solid rgba(201,147,90,0.06)',
      borderRadius: '16px', padding: '14px 18px',
      // a column now, so a version breakdown can open inside the SAME card
      // rather than as a second one floating underneath it
      display: 'flex', flexDirection: 'column',
      marginBottom: '10px',
    },
    chapterCardRow: {
      display: 'flex', alignItems: 'center', gap: '12px',
    },
    costChip: {
      background: 'transparent', border: 'none', cursor: 'pointer',
      color: '#c9935a', fontSize: '11px', flexShrink: 0,
      fontFamily: "'DM Sans', sans-serif", padding: '4px 2px',
      display: 'flex', alignItems: 'center', gap: '4px',
    },
    costChipMuted: {
      background: 'transparent', border: 'none', cursor: 'default',
      color: 'rgba(201,147,90,0.28)', fontSize: '11px', flexShrink: 0,
      fontFamily: "'DM Sans', sans-serif", padding: '4px 2px',
    },
    costBreakdown: {
      marginTop: '12px', paddingTop: '12px',
      borderTop: '1px solid rgba(201,147,90,0.1)',
    },
    costVersionRow: {
      display: 'flex', alignItems: 'baseline', gap: '8px',
      fontSize: '11px', color: '#4a3d30', padding: '3px 0',
    },
    costVersionLabel: { color: '#c9935a', flexShrink: 0, width: '46px' },
    costVersionModel: {
      flex: 1, minWidth: 0, overflow: 'hidden',
      textOverflow: 'ellipsis', whiteSpace: 'nowrap',
    },
    costFailed: { color: '#e0a0a0' },
    costTotalsRow: {
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      marginBottom: '16px', fontSize: '11px', color: '#4a3d30',
    },
    costTotalsFigure: { color: '#c9935a' },
    checkbox: (checked) => ({
      width: '18px', height: '18px', borderRadius: '5px', flexShrink: 0,
      border: `1px solid ${checked ? '#c9935a' : 'rgba(201,147,90,0.25)'}`,
      background: checked ? '#c9935a' : 'transparent',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: '11px', color: '#0e0b0f', cursor: 'pointer',
    }),
    chapterClickArea: {
      flex: 1, display: 'flex', alignItems: 'center', gap: '14px',
      cursor: 'pointer', minWidth: 0,
    },
    chapterNum: {
      width: '32px', height: '32px', borderRadius: '10px',
      background: 'rgba(201,147,90,0.08)', color: '#c9935a',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: '13px', flexShrink: 0,
    },
    chapterInfo: { flex: 1, overflow: 'hidden' },
    chapterName: {
      fontFamily: "'Cormorant Garamond', serif",
      fontSize: '17px', fontWeight: 300, color: '#e8ddd0', marginBottom: '2px',
      whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
    },
    chapterStatus: { fontSize: '11px', color: '#4a3d30' },
    charCount: { color: 'rgba(201,147,90,0.45)' },
    sectionCounts: {
      fontSize: '10px', letterSpacing: '0.1em', textTransform: 'uppercase',
      color: 'rgba(201,147,90,0.4)',
    },
    statusDot: (translated) => ({
      width: '7px', height: '7px', borderRadius: '50%',
      background: translated ? '#c9935a' : 'rgba(201,147,90,0.15)',
      display: 'inline-block', marginRight: '6px',
    }),
    deleteBtn: {
      background: 'transparent', border: 'none', cursor: 'pointer',
      color: '#4a3d30', fontSize: '15px', flexShrink: 0, padding: '4px',
    },
    deleteConfirmBtn: {
      background: 'rgba(180,60,60,0.15)', border: '1px solid rgba(220,100,100,0.3)',
      borderRadius: '8px', cursor: 'pointer', color: '#e0a0a0',
      fontSize: '11px', flexShrink: 0, padding: '5px 9px',
      fontFamily: "'DM Sans', sans-serif",
    },
    emptyState: {
      background: '#1e1825', border: '1px dashed rgba(201,147,90,0.15)',
      borderRadius: '18px', padding: '48px 24px',
      textAlign: 'center', marginBottom: '10px', cursor: 'pointer',
    },
    emptyActions: {
      display: 'flex', gap: '10px', justifyContent: 'center',
      marginTop: '18px', flexWrap: 'wrap',
    },
    emptyText: { fontSize: '14px', color: '#4a3d30', lineHeight: 1.8 },
    modalOverlay: {
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 200, padding: '24px',
    },
    modal: {
      background: '#1e1825', border: '1px solid rgba(201,147,90,0.15)',
      borderRadius: '20px', padding: '28px', width: '100%', maxWidth: '420px',
      maxHeight: '80vh', display: 'flex', flexDirection: 'column',
    },
    modalTitle: {
      fontFamily: "'Cormorant Garamond', serif",
      fontSize: '22px', fontStyle: 'italic', color: '#e8ddd0', marginBottom: '18px',
    },
    modalInput: {
      width: '100%', background: '#120f18', border: '1px solid rgba(201,147,90,0.15)',
      borderRadius: '10px', padding: '12px 14px', color: '#e8ddd0',
      fontSize: '14px', fontFamily: "'DM Sans', sans-serif", marginBottom: '18px',
      boxSizing: 'border-box', outline: 'none',
    },
    modalActions: { display: 'flex', gap: '10px', justifyContent: 'flex-end' },
    modalCancel: {
      padding: '9px 18px', borderRadius: '20px', border: 'none',
      background: 'transparent', color: '#4a3d30', fontSize: '13px', cursor: 'pointer',
      fontFamily: "'DM Sans', sans-serif",
    },
    modalCreate: {
      padding: '9px 18px', borderRadius: '20px', border: 'none',
      background: 'linear-gradient(135deg, #8a5f35, #c9935a)', color: '#0e0b0f',
      fontSize: '13px', cursor: 'pointer', fontWeight: 400,
      fontFamily: "'DM Sans', sans-serif",
    },
    epubList: { overflowY: 'auto', marginBottom: '18px', flex: 1 },
    epubRangeRow: {
      display: 'flex', flexDirection: 'column', gap: '14px', marginBottom: '18px',
    },
    epubRangeField: { display: 'flex', flexDirection: 'column', gap: '6px' },
    epubRangeLabel: {
      fontSize: '11px', letterSpacing: '0.1em', color: '#4a3d30', textTransform: 'uppercase',
    },
    epubHint: {
      fontSize: '11px', color: '#4a3d30', lineHeight: 1.6, marginTop: '-4px',
    },
    epubRow: {
      display: 'flex', alignItems: 'center', gap: '10px',
      padding: '10px 4px', borderBottom: '1px solid rgba(201,147,90,0.06)',
      fontSize: '13px', color: '#e8ddd0', cursor: 'pointer',
    },
  };

  if (loading) return <div style={s.page} />;

  return (
    <div style={s.page}>
      <link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;1,300;1,400&family=DM+Sans:wght@300;400&display=swap" rel="stylesheet" />

      {/* HEADER */}
      <header style={s.header}>
        <button style={s.backBtn} onClick={() => navigate('/novels')}>← back</button>
        {renaming ? (
          <input
            style={s.headerTitleInput}
            value={titleDraft}
            autoFocus
            onChange={e => setTitleDraft(e.target.value)}
            onBlur={saveRename}
            onKeyDown={e => e.key === 'Enter' && saveRename()}
          />
        ) : (
          <div style={s.headerTitle} onClick={() => setRenaming(true)} title="tap to rename">
            {novel?.title || 'untitled'} ✎
          </div>
        )}
        <div style={s.headerActions}>
          <button
            style={s.coverBtn}
            onClick={() => { setShowGlossary(!showGlossary); if (!showGlossary) fetchGlossary(); }}
            title="glossary — the names this novel has locked in"
          >
            <BookIcon size={15} color="#c9935a" />
          </button>
          <button style={s.coverBtn} onClick={() => { setShowSettings(!showSettings); if (!showSettings) fetchPrompts(); }} title="prompt settings">
            <GearIcon size={15} color="#c9935a" />
          </button>
          <label style={s.coverBtn} title={novel?.cover_url ? 'change cover' : 'add cover'}>
            {uploadingCover ? '…' : <ImageIcon size={15} color="#c9935a" />}
            <input
              type="file"
              accept="image/*"
              style={{ display: 'none' }}
              onChange={e => uploadCover(e.target.files?.[0])}
            />
          </label>
          <label style={s.coverBtn} title="import epub as chapters">
            {importingEpub ? '…' : <UploadIcon size={15} color="#c9935a" />}
            <input
              type="file"
              accept=".epub,application/epub+zip"
              style={{ display: 'none' }}
              onChange={e => { importEpub(e.target.files?.[0]); e.target.value = ''; }}
            />
          </label>
          <button style={s.coverBtn} onClick={() => setShowEpubModal(true)} title="download epub">
            <DownloadIcon size={15} color="#c9935a" />
          </button>
          <button style={s.plusBtn} onClick={createChapter} title="add chapter">
            <PlusIcon size={16} color="#0e0b0f" />
          </button>
        </div>
      </header>

      {/* COVER PREVIEW — small strip under the header if a cover is set */}
      {novel?.cover_url && (
        <div style={s.coverStrip}>
          <img src={novel.cover_url} alt="cover" style={s.coverThumb} />
          <span style={s.coverStripText}>this cover will be used when you generate an epub</span>
        </div>
      )}

      {/* WHAT THIS NOVEL HAS COST — always on screen, never scrolls away */}
      {costs && (
        <div style={s.spendStrip}>
          {/* what the raws cost — click the figure to set it */}
          <span style={s.spendGroup}>
            <span style={s.spendLabel}>book</span>
            {editingBookCost ? (
              <input
                style={s.spendInput}
                autoFocus
                inputMode="decimal"
                value={bookCostDraft}
                placeholder="0.00"
                onChange={e => setBookCostDraft(e.target.value)}
                onBlur={saveBookCost}
                onKeyDown={e => {
                  if (e.key === 'Enter') saveBookCost();
                  if (e.key === 'Escape') setEditingBookCost(false);
                }}
              />
            ) : (
              <span
                style={s.spendFigureQuiet}
                title="what you paid for the raws — click to set it"
                onClick={() => {
                  setBookCostDraft(costs.book_cost_usd ? String(costs.book_cost_usd) : '');
                  setEditingBookCost(true);
                }}
              >
                {money(costs.book_cost_usd)}
              </span>
            )}
          </span>

          <span style={s.spendSep}>+</span>

          <span style={s.spendGroup}>
            <span style={s.spendLabel}>translation</span>
            <span style={s.spendFigureQuiet} title="every version and every failed piece">
              {money(costs.translation_usd)}
            </span>
          </span>

          <span style={s.spendSep}>=</span>

          <span style={s.spendGroup}>
            <span style={s.spendLabel}>total</span>
            <span style={s.spendFigure}>{money(costs.grand_total_usd)}</span>
          </span>

          {costs.novel_failed_usd > 0 && (
            <span style={s.spendDetail}>
              · <span style={s.costFailed}>{money(costs.novel_failed_usd)}</span> of the translation was work that failed
            </span>
          )}
          {costs.novel_glossary_usd > 0 && (
            <span style={s.spendDetail}>· {money(costs.novel_glossary_usd)} glossary</span>
          )}
          {costs.deleted_chapters_usd > 0 && (
            <button style={s.deletedCostBtn} onClick={() => setShowDeletedCosts(v => !v)}
              title="what chapters you've deleted cost — not counted in the totals">
              · {money(costs.deleted_chapters_usd)} on deleted chapters {showDeletedCosts ? '▴' : '▾'}
            </button>
          )}
          {showDeletedCosts && costs.deleted_chapters_usd > 0 && (
            <div style={s.deletedCostList}>
              {(costs.deleted_chapters || []).map(d => (
                <div key={d.chapter_id} style={s.costVersionRow}>
                  <span style={s.costVersionModel}>{d.title || 'a chapter deleted before this was tracked'}</span>
                  <span>{money(d.total_usd)}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* YOUR READING — status, the months you read it, and your notes */}
      {novel && (
        <div style={s.readingStrip}>
          <span style={s.readingGroup}>
            <span style={s.spendLabel}>reading</span>
            <select
              style={s.readingSelect}
              value={novel.reading_status || ''}
              onChange={e => saveReading({ reading_status: e.target.value })}
            >
              <option value="">not set</option>
              {READING_STATUSES.map(st => (
                <option key={st.value} value={st.value}>{st.label}</option>
              ))}
            </select>
          </span>

          {novel.reading_status && novel.reading_status !== 'want' && (
            <span style={s.readingGroup}>
              <span style={s.spendLabel}>started</span>
              <input
                type="month"
                style={s.readingMonth}
                value={novel.started_month || ''}
                onChange={e => saveReading({ started_month: e.target.value })}
              />
            </span>
          )}

          {(novel.reading_status === 'finished' || novel.reading_status === 'dropped') && (
            <>
              <span style={s.readingGroup}>
                <span style={s.spendLabel}>{novel.reading_status}</span>
                <input
                  type="month"
                  style={s.readingMonth}
                  value={novel.finished_month || ''}
                  onChange={e => saveReading({ finished_month: e.target.value })}
                />
              </span>
              <span style={s.readingGroup}>
                <span style={s.spendLabel}>at</span>
                <select
                  style={s.readingSelect}
                  value={novel.stopped_chapter_id || ''}
                  onChange={e => saveReading({ stopped_chapter_id: e.target.value })}
                >
                  <option value="">— chapter —</option>
                  {chapters.map(c => (
                    <option key={c.id} value={c.id}>{c.title || `chapter ${c.order}`}</option>
                  ))}
                </select>
              </span>
            </>
          )}

          {/* time spent reading it, from the reading timer on the study page */}
          {novel.time_read && novel.time_read.seconds >= 60 && (
            <span style={s.readingGroup} title={`${novel.time_read.sessions} reading session${novel.time_read.sessions === 1 ? '' : 's'}`}>
              <span style={s.spendLabel}>time read</span>
              <span style={{ fontSize: '12px', color: '#c9a57a' }}>
                {Math.floor(novel.time_read.seconds / 3600) ? `${Math.floor(novel.time_read.seconds / 3600)}h ` : ''}{Math.floor((novel.time_read.seconds % 3600) / 60)}m
                {novel.time_read.reading_now ? ' · reading now' : ''}
              </span>
            </span>
          )}

          <button style={s.notesBtn} onClick={() => navigate(`/novels/${id}/notes`)}>
            ✎ notes{novel.note_count ? ` (${novel.note_count})` : ''}
          </button>

          {novel.reading_status === 'dropped' && (
            <input
              style={s.readingReason}
              placeholder="why you dropped it (optional)"
              value={dropReasonDraft !== null ? dropReasonDraft : (novel.drop_reason || '')}
              onChange={e => setDropReasonDraft(e.target.value)}
              onBlur={saveDropReason}
              onKeyDown={e => e.key === 'Enter' && e.currentTarget.blur()}
            />
          )}

          {novel.latest_note && (
            <div style={s.notesPreview} onClick={() => navigate(`/novels/${id}/notes`)}>
              latest · {new Date(novel.latest_note.created_at).toLocaleDateString([], { month: 'short', day: 'numeric' })}
              {' — '}{novel.latest_note.content}
            </div>
          )}
        </div>
      )}

      {showGlossary && (
        <div style={s.glossaryPanel}>
          <div style={s.settingsTitle}>glossary</div>
          <div style={s.glossaryHint}>
            change a name here and it is rewritten through the whole novel —
            the chapter you're reading, every saved version, every piece. built
            automatically as chapters translate — a cheap model
            {captureModel ? ` (${captureModel})` : ''} reads each finished piece
            and locks the names it used, so chapter forty calls her what chapter
            one called her. the first rendering wins, so fix one here and every
            chapter you translate after will follow. chapters already written
            are not rewritten.
          </div>

          {pendingRename && (
            <div style={s.renameBar}>
              rename <strong>{pendingRename.oldEn}</strong> to{' '}
              <strong style={{ color: '#c9935a' }}>{pendingRename.newEn}</strong>{' '}
              in <strong>{pendingRename.replaced}</strong> place
              {pendingRename.replaced === 1 ? '' : 's'} across{' '}
              <strong>{pendingRename.chapters}</strong> chapter
              {pendingRename.chapters === 1 ? '' : 's'}?
              <div style={{ color: '#4a3d30', marginTop: '4px' }}>
                this rewrites the text you're reading, every saved version and
                every piece. it can't be undone, and it's free — no model call.
              </div>
              <div style={s.renameActions}>
                <button
                  style={renamingTerm ? s.smallBtnDisabled : s.smallBtnFilled}
                  onClick={confirmRename}
                  disabled={renamingTerm}
                >
                  {renamingTerm ? 'renaming…' : 'rename everywhere'}
                </button>
                <button style={s.modalCancel} onClick={() => { setPendingRename(null); fetchGlossary(); }}>
                  cancel
                </button>
              </div>
            </div>
          )}

          {glossaryLoading ? (
            <div style={s.glossaryHint}>loading…</div>
          ) : glossary.length === 0 ? (
            <div style={s.glossaryHint}>
              nothing yet — translate a chapter and the names will appear here.
              you can also add one by hand below.
            </div>
          ) : (
            glossary.map(t => (
              <div key={t.id} style={s.glossaryRow}>
                <input
                  // keyed on the value so a save the server REFUSED snaps the
                  // box back to the truth instead of sitting there showing you
                  // an edit that never happened
                  key={`src-${t.src}`}
                  style={{ ...s.glossaryInput, opacity: t.locked ? 1 : 0.45 }}
                  defaultValue={t.src}
                  title="the Korean as it appears in the text"
                  onBlur={e => {
                    const v = e.target.value.trim();
                    if (v && v !== t.src) updateGlossaryTerm(t.id, { src: v });
                  }}
                />
                <span style={s.glossaryArrow}>→</span>
                <input
                  key={`en-${t.en}`}
                  style={{ ...s.glossaryInput, opacity: t.locked ? 1 : 0.45 }}
                  defaultValue={t.en}
                  title="the name as it is written in the translation"
                  onBlur={e => {
                    const v = e.target.value.trim();
                    if (v && v !== t.en) askRename(t, v);
                  }}
                />
                <span style={s.glossaryKind}>{t.kind || ''}</span>
                <select
                  style={{
                    ...s.pronounSelect,
                    opacity: t.kind === 'place' || t.kind === 'group' ? 0.4 : 1,
                  }}
                  value={t.pronouns || ''}
                  // people and titles can carry pronouns. A title only gets
                  // them when you set it (the clerk never does), for books
                  // where it always means the same character. Places and
                  // groups never do.
                  disabled={t.kind === 'place' || t.kind === 'group'}
                  onChange={e => updateGlossaryTerm(t.id, { pronouns: e.target.value || null })}
                  title={t.kind === 'place' || t.kind === 'group'
                    ? `a ${t.kind} can't carry pronouns`
                    : t.kind === 'title'
                      ? 'set this only if the title always means the same character — it then uses these pronouns in every chapter'
                      : 'korean drops the subject constantly — a character with pronouns carries them into every chapter'}
                >
                  <option value="">—</option>
                  <option value="she">she/her</option>
                  <option value="he">he/him</option>
                  <option value="they">they/them</option>
                </select>
                <button
                  style={s.glossaryDelete}
                  onClick={() => deleteGlossaryTerm(t.id)}
                  title="remove this term"
                >
                  <TrashIcon size={14} color="#4a3d30" />
                </button>
              </div>
            ))
          )}

          <div style={s.glossaryAddRow}>
            <input
              style={s.glossaryInput}
              value={newSrc}
              placeholder="한국어"
              onChange={e => setNewSrc(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && addGlossaryTerm()}
            />
            <span style={s.glossaryArrow}>→</span>
            <input
              style={s.glossaryInput}
              value={newEn}
              placeholder="english"
              onChange={e => setNewEn(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && addGlossaryTerm()}
            />
            <select
              style={s.pronounSelect}
              value={newPronouns}
              onChange={e => setNewPronouns(e.target.value)}
            >
              <option value="">—</option>
              <option value="she">she/her</option>
              <option value="he">he/him</option>
              <option value="they">they/them</option>
            </select>
            <button
              style={!newSrc.trim() || !newEn.trim() || addingTerm ? s.smallBtnDisabled : s.smallBtnFilled}
              onClick={addGlossaryTerm}
              disabled={!newSrc.trim() || !newEn.trim() || addingTerm}
            >
              {addingTerm ? '…' : 'add'}
            </button>
          </div>

          {glossary.length > 0 && (
            <div style={s.glossaryCount}>
              {glossary.length} term{glossary.length === 1 ? '' : 's'}
            </div>
          )}
        </div>
      )}

      {showSettings && (
        <div style={s.settingsPanel}>
          <div style={s.settingsTitle}>prompt settings</div>
          <div style={s.settingsLabel}>
            translation prompt
            <button style={s.settingsResetBtn} onClick={() => setTranslationPrompt(translationPromptDefault)}>reset to default</button>
          </div>
          <textarea
            style={s.settingsTextarea}
            value={translationPrompt}
            onChange={e => setTranslationPrompt(e.target.value)}
            placeholder="translation system prompt…"
          />
          <button style={s.settingsSaveBtn} onClick={saveTranslationPrompt} disabled={savingPrompt}>
            {savingPrompt ? 'saving…' : 'save translation prompt'}
          </button>

          <div style={{ ...s.settingsLabel, marginTop: '18px' }}>
            polish prompt
            <button style={s.settingsResetBtn} onClick={() => setPolishPrompt(polishPromptDefault)}>reset to default</button>
          </div>
          <textarea
            style={s.settingsTextarea}
            value={polishPrompt}
            onChange={e => setPolishPrompt(e.target.value)}
            placeholder="polish system prompt…"
          />
          <button style={s.settingsSaveBtn} onClick={savePolishPrompt} disabled={savingPrompt}>
            {savingPrompt ? 'saving…' : 'save polish prompt'}
          </button>
        </div>
      )}

      {/* BODY */}
      <div style={s.body} ref={bodyRef}>
        {errorMsg && (
          <div style={s.errorBanner}>
            ⚠ {errorMsg}
            {pendingEpub && (
              <div style={{ marginTop: '10px' }}>
                <button
                  style={s.smallBtn}
                  onClick={() => importEpub(pendingEpub, true)}
                  disabled={importingEpub}
                >
                  {importingEpub ? 'importing…' : 'import it anyway'}
                </button>
              </div>
            )}
          </div>
        )}
        {notice && (
          <div style={s.noticeBanner}>
            <span>
              {notice}
              {movedTo && (
                <> · <button style={s.inlineLink} onClick={() => navigate(`/novels/${movedTo.id}`)}>open {movedTo.title}</button></>
              )}
            </span>
            <button style={s.modalCancel} onClick={() => { setNotice(''); setMovedTo(null); }}>dismiss</button>
          </div>
        )}

        {/* BATCH TRANSLATE BAR */}
        {chapters.length > 0 && (
          <div style={s.batchBar}>
            <span style={s.batchLabel}>{selectedIds.length} selected</span>
            <button
              style={s.modalCancel}
              onClick={() => setSelectedIds(
                selectedIds.length === chapters.length ? [] : chapters.map(c => c.id)
              )}
            >
              {selectedIds.length === chapters.length ? 'clear all' : 'select all'}
            </button>
            <button style={s.modalCancel} onClick={() => setShowRange(v => !v)} title="select a run of chapters, like 40 to 85">
              range…
            </button>
            {showRange && (
              <span style={s.rangeRow}>
                <input style={s.rangeInput} inputMode="numeric" placeholder="from" value={rangeFrom}
                  onChange={e => setRangeFrom(e.target.value.replace(/\D/g, ''))} aria-label="from chapter" />
                <span style={s.batchLabel}>to</span>
                <input style={s.rangeInput} inputMode="numeric" placeholder="to" value={rangeTo}
                  onChange={e => setRangeTo(e.target.value.replace(/\D/g, ''))}
                  onKeyDown={e => e.key === 'Enter' && selectRange()} aria-label="to chapter" />
                <button style={s.smallBtn} onClick={selectRange}>select</button>
              </span>
            )}
            <button
              style={selectedIds.length === 0 ? s.smallBtnDisabled : s.smallBtn}
              disabled={selectedIds.length === 0}
              onClick={openMove}
              title="move the selected chapters to another book"
            >
              <MoveIcon /> move to book…
            </button>
            <select
              style={s.modelSelect}
              value={selectedModel}
              onChange={e => {
                setSelectedModel(e.target.value);
                localStorage.setItem('lastTranslationModel', e.target.value);
              }}
            >
              {models.map(m => (
                <option key={m.id} value={m.id}>{m.label}</option>
              ))}
            </select>
            <label style={s.batchLabel} title="split each chapter into pieces so the model doesn't skip content">
              <input
                type="checkbox"
                checked={batchChunked}
                onChange={e => setBatchChunked(e.target.checked)}
                style={{ marginRight: '4px', verticalAlign: 'middle' }}
              />
              chunk
            </label>
            {batchChunked && (
              <select
                style={s.modelSelect}
                value={batchChunkSize}
                onChange={e => setBatchChunkSize(Number(e.target.value))}
                title="characters per piece"
              >
                <option value={5000}>~5k per piece</option>
                <option value={10000}>~10k per piece</option>
                <option value={15000}>~15k per piece</option>
              </select>
            )}
            <button
              style={selectedIds.length === 0 || translating ? s.smallBtnDisabled : s.smallBtnFilled}
              onClick={batchTranslate}
              disabled={selectedIds.length === 0 || translating}
            >
              {translating ? 'translating…' : `✨ translate selected (${selectedIds.length})`}
            </button>
            {translating && batchId && (
              <button style={s.modalCancel} onClick={cancelBatch} title="stop after the current chapter">
                stop
              </button>
            )}
            {translateProgress && (
              <div style={s.progressText}>
                {translateProgress.status === 'cancelled'
                  ? `stopped — ${translateProgress.done} of ${translateProgress.total} done`
                  : translateProgress.done >= translateProgress.total && translateProgress.status !== 'running'
                    ? `done — ${translateProgress.total} chapter(s)`
                    : `translating ${Math.min(translateProgress.done + 1, translateProgress.total)} of ${translateProgress.total}`}
                {translateProgress.currentTitle && translateProgress.status === 'running'
                  ? ` — ${translateProgress.currentTitle}` : ''}
              </div>
            )}
            <button
              style={selectedIds.length === 0 || polishing ? s.smallBtnDisabled : s.polishBtn}
              onClick={batchPolish}
              disabled={selectedIds.length === 0 || polishing}
              title="polish selected chapters in parallel — runs on the server, you can close the app"
            >
              {polishing ? 'polishing…' : `💎 polish selected (${selectedIds.length})`}
            </button>
            {polishing && polishBatchId && (
              <button style={s.modalCancel} onClick={cancelPolishBatch}>
                stop polish
              </button>
            )}
            {polishProgress && (
              <div style={s.progressText}>
                {polishProgress.status === 'cancelled'
                  ? `polish stopped — ${polishProgress.done} of ${polishProgress.total} done`
                  : polishProgress.done >= polishProgress.total && polishProgress.status !== 'running'
                    ? `polish done — ${polishProgress.total} chapter(s)`
                    : `polishing ${polishProgress.done} of ${polishProgress.total} done`}
              </div>
            )}
          </div>
        )}

        <div style={s.sectionHeadRow}>
          <div style={{ ...s.sectionTitle, marginBottom: 0 }}>
            chapters
            {totalKo > 0 && (
              <span style={s.sectionCounts}>
                {'  ·  '}{chars(totalKo)} ko
                {totalEn > 0 && ` → ${chars(totalEn)} en`}
              </span>
            )}
          </div>
          <span style={s.reorderActions}>
          {reordering ? (
            <span style={s.reorderActions}>
              <button style={s.modalCancel} onClick={cancelReorder} disabled={savingOrder}>cancel</button>
              <button style={savingOrder ? s.smallBtnDisabled : s.smallBtnFilled} onClick={saveOrder} disabled={savingOrder}>
                {savingOrder ? 'saving…' : 'save order'}
              </button>
            </span>
          ) : chapters.length > 1 && (
            <button style={s.addVolumeBtn} onClick={startReorder} title="drag chapters into a new order">
              <GripIcon size={13} color="#c9935a" /> reorder
            </button>
          )}
          {chapters.length > 0 && !reordering && (
            <label style={s.addVolumeBtn} title="add another volume's epub to this novel — chapters it already has are skipped">
              {importingEpub ? 'importing…' : '⇧ add a volume'}
              <input
                type="file"
                accept=".epub,application/epub+zip"
                style={{ display: 'none' }}
                onChange={e => { importEpub(e.target.files?.[0]); e.target.value = ''; }}
              />
            </label>
          )}
          </span>
        </div>

        {chapters.length === 0 ? (
          <div style={s.emptyState}>
            <div style={s.emptyText} onClick={createChapter}>no chapters yet ✍️<br />tap here to add your first one</div>
            <div style={s.emptyActions}>
              <label style={s.smallBtn} onClick={e => e.stopPropagation()}>
                {importingEpub ? 'importing…' : '⇧ import from epub'}
                <input
                  type="file"
                  accept=".epub,application/epub+zip"
                  style={{ display: 'none' }}
                  onChange={e => { importEpub(e.target.files?.[0]); e.target.value = ''; }}
                />
              </label>
            </div>
          </div>
        ) : reordering ? (
          <div ref={listRef}>
            <div style={s.reorderHint}>
              drag the <GripIcon size={12} /> handle, or type a new number. nothing changes until you save.
            </div>
            {orderDraft.map((c, i) => (
              <div
                key={c.id}
                data-cid={c.id}
                style={{ ...s.chapterCard, ...s.reorderCard, ...(dragId === c.id ? s.reorderCardDragging : {}) }}
              >
                <div style={s.chapterCardRow}>
                  <div
                    style={s.grip}
                    onPointerDown={e => onGripDown(e, c.id)}
                    onPointerMove={onGripMove}
                    onPointerUp={onGripUp}
                    onPointerCancel={onGripUp}
                    aria-label={`drag ${c.title || `chapter ${i + 1}`}`}
                    role="button"
                  >
                    <GripIcon />
                  </div>
                  <input
                    key={`${c.id}-${i}`}
                    style={s.positionInput}
                    inputMode="numeric"
                    defaultValue={i + 1}
                    aria-label="position"
                    onFocus={e => e.target.select()}
                    onBlur={e => {
                      const n = parseInt(e.target.value, 10);
                      if (n && n !== i + 1) moveTo(c.id, n - 1); else e.target.value = i + 1;
                    }}
                    onKeyDown={e => e.key === 'Enter' && e.currentTarget.blur()}
                  />
                  <div style={s.chapterInfo}>
                    <div style={s.chapterName}>{c.title || `chapter ${i + 1}`}</div>
                  </div>
                  <button style={s.edgeBtn} onClick={() => moveTo(c.id, 0)} disabled={i === 0} title="move to the top">top</button>
                  <button style={s.edgeBtn} onClick={() => moveTo(c.id, orderDraft.length - 1)} disabled={i === orderDraft.length - 1} title="move to the bottom">bottom</button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          chapters.map((c, i) => {
            const cost = costs?.chapters?.[c.id];
            const open = openCost === c.id;
            return (
            <div key={c.id} style={s.chapterCard}>
              <div style={s.chapterCardRow}>
                <div style={s.checkbox(selectedIds.includes(c.id))} onClick={() => toggleSelected(c.id)}>
                  {selectedIds.includes(c.id) ? '✓' : ''}
                </div>
                <div style={s.chapterClickArea} onClick={() => navigate(`/novels/${id}/chapters/${c.id}`)}>
                  <div style={s.chapterNum}>{i + 1}</div>
                  <div style={s.chapterInfo}>
                    <div style={s.chapterName}>{c.title || `chapter ${i + 1}`}</div>
                    <div style={s.chapterStatus}>
                      <span style={s.statusDot(c.is_translated)} />
                      {c.is_translated ? 'translated' : 'not translated yet'}
                      {c.source_chars > 0 && (
                        <span style={s.charCount}>
                          {' · '}{chars(c.source_chars)} ko
                          {c.translated_chars > 0
                            ? ` → ${chars(c.translated_chars)} en`
                            : c.partial_chars > 0
                              // a run that part-failed wrote real English; say
                              // how far it got rather than showing nothing
                              ? ` → ${chars(c.partial_chars)} en (partial)`
                              : ''}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                {/* every version of this chapter added together, failures
                    included — tap to see which version spent what */}
                {cost ? (
                  <button
                    style={s.costChip}
                    onClick={() => setOpenCost(open ? null : c.id)}
                    title="what this chapter has cost, every version and every failed piece"
                  >
                    {money(cost.total_usd)}
                    <span style={{ opacity: 0.5 }}>{open ? '▴' : '▾'}</span>
                  </button>
                ) : (
                  <span style={s.costChipMuted}>—</span>
                )}
                {confirmDeleteId === c.id ? (
                  <button
                    style={s.deleteConfirmBtn}
                    onClick={() => deleteChapter(c.id)}
                    disabled={deleting}
                  >
                    {deleting ? '…' : 'confirm?'}
                  </button>
                ) : (
                  <button style={s.deleteBtn} onClick={() => setConfirmDeleteId(c.id)} title="delete chapter">
                    <TrashIcon size={15} color="#4a3d30" />
                  </button>
                )}
              </div>

              {open && cost && (
                <div style={s.costBreakdown}>
                  {cost.versions.map(v => (
                    <div key={v.id} style={s.costVersionRow}>
                      <span style={s.costVersionLabel}>{v.label}</span>
                      <span style={s.costVersionModel}>
                        {v.model}
                        {v.is_polish ? ' · polish' : ''}
                        {/* still to go, failed, and done are three different
                            things — a piece that hasn't run yet is not a
                            failure, and saying so made a chapter that was
                            translating perfectly well look broken */}
                        {v.pending_pieces > 0
                          ? ` · ${v.done_pieces} of ${v.pieces} pieces done, ${v.pending_pieces} still to go`
                          : v.failed_pieces > 0
                            ? ` · ${v.failed_pieces} of ${v.pieces} pieces failed`
                            : v.status !== 'done' ? ` · ${v.status}` : ''}
                        {v.pending_pieces > 0 && v.failed_pieces > 0
                          ? ` (${v.failed_pieces} failed)`
                          : ''}
                        {v.retries > 0
                          ? ` · ${v.retries} retr${v.retries === 1 ? 'y' : 'ies'}, each one billed`
                          : ''}
                      </span>
                      <span style={v.failed_pieces > 0 || v.status === 'error'
                        ? s.costFailed : undefined}>
                        {money(v.total_usd)}
                      </span>
                    </div>
                  ))}
                  {(cost.failed_usd > 0 || cost.glossary_usd > 0) && (
                    <div style={{ ...s.costVersionRow, marginTop: '6px' }}>
                      <span style={s.costVersionLabel} />
                      <span style={s.costVersionModel}>
                        {cost.failed_usd > 0 && (
                          <span style={s.costFailed}>
                            {money(cost.failed_usd)} of that was work that failed
                          </span>
                        )}
                        {cost.in_progress_usd > 0 && (
                          <span>
                            {cost.failed_usd > 0 ? ' · ' : ''}
                            {money(cost.in_progress_usd)} still translating
                          </span>
                        )}
                        {cost.failed_usd > 0 && cost.glossary_usd > 0 && ' · '}
                        {cost.glossary_usd > 0 && `${money(cost.glossary_usd)} glossary`}
                      </span>
                    </div>
                  )}
                </div>
              )}
            </div>
            );
          })
        )}

        {!reordering && novel && (
          <div style={s.deleteBookRow}>
            <button style={s.deleteBookLink} onClick={() => { setDeleteTitleDraft(''); setShowDeleteBook(true); }}>
              delete this book
            </button>
          </div>
        )}
      </div>

      {/* MOVE CHAPTERS MODAL */}
      {showMove && (
        <div style={s.modalOverlay} onClick={() => !moving && setShowMove(false)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <div style={s.modalTitle}>move {selectedIds.length} chapter{selectedIds.length === 1 ? '' : 's'}</div>
            <div style={s.epubHint}>
              they go to the end of the book you pick, with every translation version, what they cost,
              and your notes on them. names they use are copied to that book's glossary — its own spellings win.
            </div>
            <div style={s.bookPick}>
              {books.map(b => (
                <label key={b.id} style={s.bookOption(moveTarget === b.id)}>
                  <input type="radio" name="move-target" checked={moveTarget === b.id}
                    onChange={() => setMoveTarget(b.id)} style={{ accentColor: '#c9935a' }} />
                  <span style={s.bookOptionTitle}>{b.title}</span>
                  <span style={s.bookOptionSub}>{b.chapter_count || 0} ch</span>
                </label>
              ))}
              <label style={s.bookOption(moveTarget === 'new')}>
                <input type="radio" name="move-target" checked={moveTarget === 'new'}
                  onChange={() => setMoveTarget('new')} style={{ accentColor: '#c9935a' }} />
                <span style={s.bookOptionTitle}>a new book</span>
              </label>
              {moveTarget === 'new' && (
                <input style={s.modalInput} placeholder="the new book's title" value={newBookTitle} autoFocus
                  onChange={e => setNewBookTitle(e.target.value)} />
              )}
            </div>
            <div style={s.modalActions}>
              <button style={s.modalCancel} onClick={() => setShowMove(false)} disabled={moving}>cancel</button>
              <button
                style={!moveTarget || (moveTarget === 'new' && !newBookTitle.trim()) || moving ? s.smallBtnDisabled : s.modalCreate}
                disabled={!moveTarget || (moveTarget === 'new' && !newBookTitle.trim()) || moving}
                onClick={doMove}
              >
                {moving ? 'moving…' : 'move them'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* DELETE BOOK MODAL */}
      {showDeleteBook && (
        <div style={s.modalOverlay} onClick={() => !deletingBook && setShowDeleteBook(false)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <div style={s.modalTitle}>delete this book?</div>
            <div style={s.deleteSummary}>
              <b>{novel?.title}</b> and its {chapters.length} chapter{chapters.length === 1 ? '' : 's'}
              {costs && costs.translation_usd > 0 ? <> ({money(costs.translation_usd)} of translation)</> : null}
              {' '}go to <b>recently deleted</b> in your library. you can bring it all back for 30 days —
              after that it's gone for good.
            </div>
            <button style={{ ...s.smallBtn, alignSelf: 'flex-start', marginBottom: '14px' }}
              onClick={() => { setShowDeleteBook(false); setShowEpubModal(true); }}>
              download an epub first
            </button>
            <div style={s.epubRangeLabel}>type the title to confirm</div>
            <input style={s.modalInput} value={deleteTitleDraft} placeholder={novel?.title}
              onChange={e => setDeleteTitleDraft(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && deleteBook()} />
            <div style={s.modalActions}>
              <button style={s.modalCancel} onClick={() => setShowDeleteBook(false)} disabled={deletingBook}>keep it</button>
              <button
                style={deleteTitleDraft.trim() === (novel?.title || '').trim() && !deletingBook ? s.dangerBtn : s.smallBtnDisabled}
                disabled={deleteTitleDraft.trim() !== (novel?.title || '').trim() || deletingBook}
                onClick={deleteBook}
              >
                {deletingBook ? 'deleting…' : 'delete book'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* GENERATE EPUB MODAL */}
      {showEpubModal && (
        <div style={s.modalOverlay} onClick={() => setShowEpubModal(false)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <div style={s.modalTitle}>generate epub</div>
            {chapters.filter(c => c.is_translated).length === 0 ? (
              <div style={{ ...s.emptyText, padding: '12px 0', marginBottom: '18px' }}>
                no translated chapters yet — translate a chapter first
              </div>
            ) : (
              <div style={s.epubRangeRow}>
                <div style={s.epubRangeField}>
                  <div style={s.epubRangeLabel}>from chapter</div>
                  <select
                    style={s.modalInput}
                    value={epubFrom}
                    onChange={e => setEpubFrom(Number(e.target.value))}
                  >
                    {chapters.map((c, i) => (
                      <option key={c.id} value={i + 1}>
                        {i + 1}. {c.title || `chapter ${i + 1}`}{c.is_translated ? '' : '  (not translated)'}
                      </option>
                    ))}
                  </select>
                </div>
                <div style={s.epubRangeField}>
                  <div style={s.epubRangeLabel}>to chapter</div>
                  <select
                    style={s.modalInput}
                    value={epubTo}
                    onChange={e => setEpubTo(Number(e.target.value))}
                  >
                    {chapters.map((c, i) => (
                      <option key={c.id} value={i + 1}>
                        {i + 1}. {c.title || `chapter ${i + 1}`}{c.is_translated ? '' : '  (not translated)'}
                      </option>
                    ))}
                  </select>
                </div>
                <div style={s.epubHint}>
                  untranslated chapters in your range are skipped automatically
                </div>
                <button style={s.modalCancel} onClick={selectAllForEpub}>select all</button>
              </div>
            )}
            <div style={s.modalActions}>
              <button style={s.modalCancel} onClick={() => setShowEpubModal(false)}>cancel</button>
              <button
                style={s.modalCreate}
                onClick={generateEpub}
                disabled={generating || chapters.filter(c => c.is_translated).length === 0}
              >
                {generating ? 'generating…' : 'generate'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
